/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const luisAppListPageMessages = defineMessages({
    pageTitle: {
        id: 'luis.luisAppListPage.pageTitle',
        defaultMessage: 'Conversation apps'
    },
    pageTitleDescription: {
        id: 'luis.luisAppListPage.pageTitleDescription',
        defaultMessage: 'Manage LUIS apps, designed to identify user goals and valuable information from text.'
    },
    emptyTablePlaceholder: {
        id: 'luis.luisAppListPage.emptyTablePlaceholder',
        defaultMessage: "You don't have any apps yet."
    },
    noResults: {
        id: 'luis.luisAppListPage.noResults',
        defaultMessage: 'No results found'
    },
    noSubscriptionOrResourceGroupTablePlaceholder: {
        id: 'luis.luisAppListPage.noSubscriptionOrResourceGroupTablePlaceholder',
        defaultMessage: 'Please select a subscription and authoring resource first.'
    },
    createAppToastStart: {
        id: 'luis.luisAppListPage.createAppToastStart',
        defaultMessage: 'Creating app ...'
    },
    createAppToastSuccess: {
        id: 'luis.luisAppListPage.createAppToastSuccess',
        defaultMessage: 'Create app completed'
    },
    createAppToastFailed: {
        id: 'luis.luisAppListPage.createAppToastFailed',
        defaultMessage: 'Create app failed'
    },
    importApp: {
        id: 'luis.luisAppListPage.importApp',
        defaultMessage: 'Import new app'
    },
    importAppToastStart: {
        id: 'luis.luisAppListPage.importAppToastStart',
        defaultMessage: 'Importing app ...'
    },
    importAppToastSuccess: {
        id: 'luis.luisAppListPage.importAppToastSuccess',
        defaultMessage: 'Import app completed'
    },
    importAppToastFailed: {
        id: 'luis.luisAppListPage.importAppToastFailed',
        defaultMessage: 'Import app failed'
    },
    deleteAppTitle: {
        id: 'luis.luisAppListPage.deleteAppTitle',
        defaultMessage: 'Delete selected app(s)?'
    },
    deleteAppBody: {
        id: 'luis.luisAppListPage.deleteAppBody',
        defaultMessage: 'Are you sure you want to delete the selected app(s)?'
    },
    renameApp: {
        id: 'luis.luisAppListPage.renameApp',
        defaultMessage: 'Rename app'
    },
    renameAppToastStart: {
        id: 'luis.luisAppListPage.renameAppToastStart',
        defaultMessage: 'Renaming app ...'
    },
    renameAppToastSuccess: {
        id: 'luis.luisAppListPage.renameAppToastSuccess',
        defaultMessage: 'Rename app completed'
    },
    renameAppToastFailed: {
        id: 'luis.luisAppListPage.renameAppToastFailed',
        defaultMessage: 'Rename app failed'
    },
    exportAppToastStart: {
        id: 'luis.luisAppListPage.exportAppToastStart',
        defaultMessage: 'Exporting app ...'
    },
    exportAppToastSuccess: {
        id: 'luis.luisAppListPage.exportAppToastSuccess',
        defaultMessage: 'Export app completed'
    },
    exportAppToastFailed: {
        id: 'luis.luisAppListPage.exportAppToastFailed',
        defaultMessage: 'Export app failed'
    },
    importAppLogsToastStart: {
        id: 'luis.luisAppListPage.importAppLogsToastStart',
        defaultMessage: 'Importing app logs ...'
    },
    importAppLogsToastSuccess: {
        id: 'luis.luisAppListPage.importAppLogsToastSuccess',
        defaultMessage: 'Import app logs completed'
    },
    importAppLogsToastFailed: {
        id: 'luis.luisAppListPage.importAppLogsToastFailed',
        defaultMessage: 'Import app logs failed'
    },
    exportAppLogsToastStart: {
        id: 'luis.luisAppListPage.exportAppLogsToastStart',
        defaultMessage: 'Exporting app logs ...'
    },
    exportAppLogsToastSuccess: {
        id: 'luis.luisAppListPage.exportAppLogsToastSuccess',
        defaultMessage: 'Export app logs completed'
    },
    exportAppLogsToastFailed: {
        id: 'luis.luisAppListPage.exportAppLogsToastFailed',
        defaultMessage: 'Export app logs failed'
    },
    deleteAppToastStart: {
        id: 'luis.luisAppListPage.deleteAppToastStart',
        defaultMessage: 'Deleting app(s) ...'
    },
    deleteAppToastSuccess: {
        id: 'luis.luisAppListPage.deleteAppToastSuccess',
        defaultMessage: 'Delete apps completed'
    },
    deleteAppToastFailed: {
        id: 'luis.luisAppListPage.deleteAppToastFailed',
        defaultMessage: 'Delete apps failed'
    }
});
